import { Divider, IconButton, TextField } from "@mui/material";
import Close from "@mui/icons-material/Close";
import RepeatIcon from "@mui/icons-material/Repeat";
import Schedule from "@mui/icons-material/Schedule";
import { useState } from "react";
import { emptyRepeat, Repeat, RepeatKind } from "../../../api/Tasks";
import { Dropdown } from "../../../misc/Dropdown";
import { TinyButton } from "../../../misc/TinyButton";
import { panelWidth, PickDate } from "./PickDate";
import { RepeatDetails } from "./RepeatDetails";
import { repeatKinds, seedRepeat } from "../repeatText";
import { panelFontSize } from "./PanelSection";

export function DueDatePanel(props: {
    dueDate: string;
    dueTime: string;
    repeat: Repeat;
    onChange: (changes: { dueDate?: string; dueTime?: string; repeat?: Repeat }) => void;

    // hideRepeat drops the repeat controls, for a task that can't carry one (see
    // core/task)
    hideRepeat?: boolean;
}) {
    const [showTime, setShowTime] = useState(!!props.dueTime);
    const [showRepeat, setShowRepeat] = useState(!!props.repeat.kind);
    const [repeatMenuOpen, setRepeatMenuOpen] = useState(false);

    return (
        <div style={{ width: panelWidth }}>
            <PickDate
                value={props.dueDate}
                onChange={value => props.onChange({ dueDate: value })}
                onClear={() => {
                    setShowTime(false);
                    props.onChange({ dueDate: "", dueTime: "" });
                }}
            />

            <Divider />

            <div style={{ padding: 12, display: "flex", flexDirection: "column", gap: 8 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 4, minHeight: 30 }}>
                    {props.hideRepeat ? null : showRepeat ? (
                        <>
                            <RepeatIcon fontSize="small" htmlColor="#616161" />
                            <Dropdown
                                width={130}
                                value={props.repeat.kind}
                                options={repeatKinds}
                                open={repeatMenuOpen}
                                onOpen={() => setRepeatMenuOpen(true)}
                                onClose={() => setRepeatMenuOpen(false)}
                                onChange={(kind: RepeatKind) =>
                                    props.onChange({ repeat: seedRepeat(props.repeat, { kind: kind }, props.dueDate || null) })}
                            />
                            <IconButton size="small" aria-label="Clear repeat" onClick={() => {
                                setShowRepeat(false);
                                props.onChange({ repeat: emptyRepeat });
                            }}>
                                <Close fontSize="inherit" />
                            </IconButton>
                        </>
                    ) : (
                        <TinyButton color="primary"
                                    startIcon={<RepeatIcon fontSize="inherit" />} onClick={() => {
                            setShowRepeat(true);
                            setRepeatMenuOpen(true);
                        }}>
                            Add repeat
                        </TinyButton>
                    )}

                    <div style={{ flex: 1 }} />

                    {showTime ? (
                        <>
                            <Schedule fontSize="small" htmlColor="#616161" />
                            <TextField type="time" size="small" autoFocus style={{ width: 110 }}
                                       disabled={!props.dueDate}
                                       value={props.dueTime}
                                       onChange={e => props.onChange({ dueTime: e.target.value })}
                                       slotProps={{ htmlInput: { style: { fontSize: panelFontSize, padding: "4px 6px" } } }} />
                            <TinyButton onClick={() => {
                                setShowTime(false);
                                props.onChange({ dueTime: "" });
                            }}>
                                Clear
                            </TinyButton>
                        </>
                    ) : (
                        <TinyButton color="primary"
                                    startIcon={<Schedule fontSize="inherit" />}
                                    disabled={!props.dueDate}
                                    onClick={() => setShowTime(true)}>
                            Add time
                        </TinyButton>
                    )}
                </div>

                {showRepeat && !props.hideRepeat && (
                    <RepeatDetails
                        value={props.repeat}
                        dueDate={props.dueDate || null}
                        onChange={value => props.onChange({ repeat: value })}
                    />
                )}
            </div>
        </div>
    );
}
